export const BASKET_CHECK_TOAST_NAMES = [
    'basket-check-success',
    'basket-check-danger',
    'basket-check-warning',
    'basket-check-price-decreased'
] as const;

export const ORDER_SUCCESS_TOAST_NAMES = ['create-order', 'notice_created_order'] as const;

/** Тосты проверки корзины и оформления заказа (общая очередь ToasterProvider) */
export const ORDER_FLOW_TOAST_NAMES = [
    ...BASKET_CHECK_TOAST_NAMES,
    ...ORDER_SUCCESS_TOAST_NAMES
] as const;

type ToastRemover = (name: string) => void;
type ToastChecker = (name: string) => boolean;
type DelayFactory = (ms: number) => Promise<void>;

const sleep: DelayFactory = (ms) =>
    new Promise((resolve) => {
        window.setTimeout(resolve, ms);
    });

export const dismissToastsFromQueue = (remove: ToastRemover, names: readonly string[]) => {
    names.forEach((name) => remove(name));
};

export const dismissToastsFromQueueUntilGone = (
    remove: ToastRemover,
    has: ToastChecker,
    names: readonly string[],
    maxAttempts = 6,
    retryDelayMs = 16
) => {
    const run = async () => {
        for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
            names.forEach((name) => remove(name));

            const hasAnyTrackedToast = names.some((name) => has(name));
            if (!hasAnyTrackedToast) {
                return;
            }

            await sleep(retryDelayMs);
        }

        names.forEach((name) => remove(name));
    };

    return run();
};

export const dismissBasketCheckToastsFromQueue = (remove: ToastRemover) => {
    dismissToastsFromQueue(remove, BASKET_CHECK_TOAST_NAMES);
};

export const dismissOrderFlowToastsFromQueue = (remove: ToastRemover) => {
    dismissToastsFromQueue(remove, ORDER_FLOW_TOAST_NAMES);
};

export const dismissOrderFlowToastsFromQueueUntilGone = (remove: ToastRemover, has: ToastChecker) =>
    dismissToastsFromQueueUntilGone(remove, has, ORDER_FLOW_TOAST_NAMES);

export const isOrderFlowToastName = (name: string | null): boolean =>
    name != null && (ORDER_FLOW_TOAST_NAMES as readonly string[]).includes(name);

export const hideToasterCss = () => {
    const root = document.documentElement;
    root.style.setProperty('--g-toaster-visibility', 'hidden');
    root.style.setProperty('--g-toaster-top', '50%');
};

export const showToasterCss = () => {
    const root = document.documentElement;
    root.style.setProperty('--g-toaster-top', '50%');
    root.style.setProperty('--g-toaster-visibility', 'visible');
};
